import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "grow"
};
const _hoisted_2 = {
  class: "text-gray-500 italic"
};
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    notification: null,
    hideDelete: {
      type: Boolean
    },
    hideShow: {
      type: Boolean
    }
  },
  emits: ['delete', 'clicked-see'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const router = useRouter();
    const onClickSee = () => {
      emit('delete');
      router.push(props.notification.to);
      emit('clicked-see');
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex p-2 items-center text-sm", {
          'font-bold': !__props.notification.read,
          'text-gray-500': __props.notification.read
        }])
      }, [!__props.hideShow ? (_openBlock(), _createBlock(_component_NButton, {
        key: 0,
        text: "",
        size: "small",
        type: __props.notification.to ? 'success' : 'default',
        class: "mr-2",
        disabled: !__props.notification.to,
        onClick: onClickSee
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.EyeOutline
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["type", "disabled"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$date(__props.notification.createdAt)), 1), (_openBlock(), _createBlock(_resolveDynamicComponent(__props.notification.component), _mergeProps(_ctx.$attrs, {
        notification: __props.notification
      }), null, 16, ["notification"]))]), !__props.hideDelete ? (_openBlock(), _createBlock(_component_NButton, {
        key: 1,
        text: "",
        size: "small",
        type: "error",
        class: "ml-2",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('delete'))
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.CloseOutline
        }, null, 8, ["icon"])]),
        _: 1
      })) : _createCommentVNode("", true)], 2);
    };
  }
});